import React, { useState } from 'react';
import { signUp } from './services/api';

const LandingPage = ({ onEnter }) => {
  const [showSignUp, setShowSignUp] = useState(false);
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [signUpSuccess, setSignUpSuccess] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleQuickStart = () => {
    // Just browse without signing up
    onEnter();
  };

  const handleSignUp = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      // Call API (mock or real) to persist user
      await signUp({ email, name });

      console.log('Sign up successful:', { email, name });
      setSignUpSuccess(true);

      // Enter the app after 1.5 seconds
      setTimeout(() => {
        onEnter(email, name);
      }, 1500);
    } catch (err) {
      console.error('Sign up failed:', err);
      // For now, proceed anyway since it might be a mock env
      setSignUpSuccess(true);
      setTimeout(() => {
        onEnter(email, name);
      }, 1500);
    } finally {
      setIsSubmitting(false);
    }
  };

  if (showSignUp) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-slate-950 via-slate-900 to-orange-950 flex items-center justify-center p-4">
        <div className="max-w-md w-full">
          {/* Back button */}
          <button
            onClick={() => setShowSignUp(false)}
            className="mb-6 text-slate-400 hover:text-orange-400 transition-colors flex items-center gap-2"
          >
            ← Back
          </button>

          <div className="bg-slate-900/50 backdrop-blur-xl border border-orange-500/20 rounded-2xl p-8 shadow-2xl">
            <div className="text-center mb-8">
              <div className="text-6xl mb-4">⚡</div>
              <h2 className="text-3xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-orange-400 to-yellow-400 mb-2">
                Join the Movement
              </h2>
              <p className="text-slate-400">
                Get notified about new bounties in your area
              </p>
            </div>

            {signUpSuccess ? (
              <div className="text-center py-8">
                <div className="text-6xl mb-4 animate-bounce">🎉</div>
                <p className="text-xl font-bold text-emerald-400 mb-2">Welcome aboard!</p>
                <p className="text-slate-400">Entering the bounty board...</p>
              </div>
            ) : (
              <form onSubmit={handleSignUp} className="space-y-6">
                <div>
                  <label className="block text-sm font-medium text-slate-300 mb-2">
                    Name / Nym
                  </label>
                  <input
                    type="text"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    placeholder="SatoshiFan"
                    className="w-full bg-slate-950/50 border border-slate-700 rounded-lg px-4 py-3 text-white placeholder-slate-500 focus:outline-none focus:border-orange-500 transition-colors"
                    required
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-slate-300 mb-2">
                    Email
                  </label>
                  <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="satoshi@example.com"
                    className="w-full bg-slate-950/50 border border-slate-700 rounded-lg px-4 py-3 text-white placeholder-slate-500 focus:outline-none focus:border-orange-500 transition-colors"
                    required
                  />
                  <p className="text-xs text-slate-500 mt-2">
                    We'll email you when bounties match your interests
                  </p>
                </div>

                <button
                  type="submit"
                  className="w-full bg-gradient-to-r from-orange-500 to-yellow-500 hover:from-orange-600 hover:to-yellow-600 text-slate-950 font-bold py-4 rounded-lg transition-all duration-300 transform hover:scale-[1.02] shadow-lg hover:shadow-orange-500/50"
                >
                  Sign Up & Enter ⚡
                </button>

                <p className="text-center text-sm text-slate-500">
                  Or{' '}
                  <button
                    type="button"
                    onClick={handleQuickStart}
                    className="text-orange-400 hover:text-orange-300 underline"
                  >
                    browse without signing up
                  </button>
                </p>
              </form>
            )}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-950 via-slate-900 to-orange-950 overflow-x-hidden">
      {/* Navigation */}
      <nav className="fixed top-0 w-full z-50 bg-slate-950/80 backdrop-blur-md border-b border-orange-500/20">
        <div className="max-w-6xl mx-auto px-4 py-4 flex justify-between items-center">
          <div className="flex items-center gap-2">
            <span className="text-3xl">⚡</span>
            <span className="text-xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-orange-400 to-yellow-400">
              Sats for Shops
            </span>
          </div>
          <div className="flex gap-3">
            <button
              onClick={handleQuickStart}
              className="px-4 py-2 bg-slate-800/80 border border-slate-700 hover:border-orange-500/50 text-slate-300 hover:text-white rounded-lg transition-all"
            >
              Browse
            </button>
            <button
              onClick={() => setShowSignUp(true)}
              className="px-6 py-2 bg-gradient-to-r from-orange-500 to-yellow-500 hover:from-orange-600 hover:to-yellow-600 text-slate-950 font-bold rounded-lg transition-all duration-300 transform hover:scale-105 shadow-lg"
            >
              Sign Up
            </button>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="pt-32 pb-20 px-4">
        <div className="max-w-4xl mx-auto text-center">
          <div className="mb-8 flex justify-center">
            <img
              src="/hero-image.jpg"
              alt="Bitcoin merchant adoption at Taiwan night market"
              className="rounded-2xl shadow-2xl max-w-full h-auto border-2 border-orange-500/20"
              style={{ maxHeight: '400px' }}
            />
          </div>
          <h1 className="text-5xl md:text-6xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-orange-400 via-yellow-400 to-orange-400 mb-6 leading-tight">
            Stack Sats.<br />Onboard Merchants.<br />Build the Bitcoin Economy.
          </h1>
          <p className="text-xl text-slate-300 mb-4 max-w-2xl mx-auto leading-relaxed">
            An honor-based bounty board where Bitcoin communities pool sats together to incentivize
            <span className="text-orange-400 font-semibold"> lasting </span>
            merchant adoption in their local area.
          </p>
          <p className="text-lg text-slate-400 mb-10">
            Like bug bounties, but for the real world. 🌍
          </p>
          <div className="flex gap-4 justify-center flex-wrap">
            <button
              onClick={() => setShowSignUp(true)}
              className="px-8 py-4 bg-gradient-to-r from-orange-500 to-yellow-500 hover:from-orange-600 hover:to-yellow-600 text-slate-950 font-bold text-lg rounded-lg transition-all duration-300 transform hover:scale-105 shadow-2xl hover:shadow-orange-500/50"
            >
              Get Started ⚡
            </button>
            <button
              onClick={handleQuickStart}
              className="px-8 py-4 bg-slate-800/50 border border-slate-700 hover:border-orange-500/50 text-white font-bold text-lg rounded-lg transition-all duration-300 backdrop-blur-sm"
            >
              Explore Bounties
            </button>
          </div>
        </div>
      </section>

      {/* How It Works */}
      <section className="py-20 px-4 bg-slate-950/50">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-4xl font-bold text-center text-transparent bg-clip-text bg-gradient-to-r from-orange-400 to-yellow-400 mb-16">
            How It Works
          </h2>
          <div className="grid md:grid-cols-4 gap-8">
            <div className="text-center group">
              <div className="text-6xl mb-4 transform group-hover:scale-110 transition-transform">🎯</div>
              <h3 className="text-xl font-bold text-white mb-3">1. Create Bounties</h3>
              <p className="text-slate-400">
                Post a bounty for the type of business you want to see accept Bitcoin in your area
              </p>
            </div>
            <div className="text-center group">
              <div className="text-6xl mb-4 transform group-hover:scale-110 transition-transform">⚡</div>
              <h3 className="text-xl font-bold text-white mb-3">2. Stack Sats</h3>
              <p className="text-slate-400">
                Add your pledge to existing bounties. The bigger the bounty, the bigger the incentive
              </p>
            </div>
            <div className="text-center group">
              <div className="text-6xl mb-4 transform group-hover:scale-110 transition-transform">🏪</div>
              <h3 className="text-xl font-bold text-white mb-3">3. Onboard Merchants</h3>
              <p className="text-slate-400">
                Claim a bounty by successfully onboarding a real business. Get 33% upfront
              </p>
            </div>
            <div className="text-center group">
              <div className="text-6xl mb-4 transform group-hover:scale-110 transition-transform">✅</div>
              <h3 className="text-xl font-bold text-white mb-3">4. Verify & Earn</h3>
              <p className="text-slate-400">
                Community verifies, merchant stays active for 3 months, you get the remaining 67%
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* The Innovation */}
      <section className="py-20 px-4">
        <div className="max-w-4xl mx-auto">
          <div className="bg-gradient-to-br from-orange-500/10 to-yellow-500/10 border border-orange-500/30 rounded-2xl p-8 md:p-12 backdrop-blur-sm">
            <div className="flex items-start gap-4 mb-6">
              <span className="text-5xl">💡</span>
              <div>
                <h2 className="text-3xl font-bold text-orange-400 mb-4">
                  The Split Payout Innovation
                </h2>
                <p className="text-slate-300 text-lg leading-relaxed mb-4">
                  The problem with merchant onboarding? One-time photo ops. A business accepts one payment,
                  takes a picture, and never uses Bitcoin again.
                </p>
                <p className="text-slate-300 text-lg leading-relaxed mb-4">
                  Our solution: <span className="text-orange-400 font-bold">33% now, 67% in 3 months</span>.
                </p>
                <p className="text-slate-300 text-lg leading-relaxed">
                  You don't get the majority of the bounty until the community verifies the merchant
                  is <span className="text-emerald-400 font-bold">still accepting Bitcoin</span> three months later.
                  This aligns incentives for lasting adoption, not just vanity metrics.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Features Grid */}
      <section className="py-20 px-4 bg-slate-950/50">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-4xl font-bold text-center text-transparent bg-clip-text bg-gradient-to-r from-orange-400 to-yellow-400 mb-16">
            Why Sats for Shops?
          </h2>
          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-slate-900/50 border border-slate-800 rounded-xl p-6 hover:border-orange-500/30 transition-all">
              <div className="text-4xl mb-4">🤝</div>
              <h3 className="text-xl font-bold text-white mb-3">Honor-Based</h3>
              <p className="text-slate-400">
                No escrow, no custody, no complexity. Just Bitcoiners helping Bitcoiners build the circular economy.
              </p>
            </div>
            <div className="bg-slate-900/50 border border-slate-800 rounded-xl p-6 hover:border-orange-500/30 transition-all">
              <div className="text-4xl mb-4">🌍</div>
              <h3 className="text-xl font-bold text-white mb-3">Global but Local</h3>
              <p className="text-slate-400">
                Each meetup has their own space. Taipei sees Taipei bounties, Edmonton sees Edmonton.
              </p>
            </div>
            <div className="bg-slate-900/50 border border-slate-800 rounded-xl p-6 hover:border-orange-500/30 transition-all">
              <div className="text-4xl mb-4">👁️</div>
              <h3 className="text-xl font-bold text-white mb-3">Watch & Get Notified</h3>
              <p className="text-slate-400">
                Follow business categories you care about. Get emailed when new bounties are posted.
              </p>
            </div>
            <div className="bg-slate-900/50 border border-slate-800 rounded-xl p-6 hover:border-orange-500/30 transition-all">
              <div className="text-4xl mb-4">💬</div>
              <h3 className="text-xl font-bold text-white mb-3">Coordination Built-In</h3>
              <p className="text-slate-400">
                Comment threads on every bounty. Share tips, coordinate approaches, celebrate wins.
              </p>
            </div>
            <div className="bg-slate-900/50 border border-slate-800 rounded-xl p-6 hover:border-orange-500/30 transition-all">
              <div className="text-4xl mb-4">🗺️</div>
              <h3 className="text-xl font-bold text-white mb-3">Google Maps Integration</h3>
              <p className="text-slate-400">
                Every claimed business links to Google Maps. Easy for the community to visit and verify.
              </p>
            </div>
            <div className="bg-slate-900/50 border border-slate-800 rounded-xl p-6 hover:border-orange-500/30 transition-all">
              <div className="text-4xl mb-4">📊</div>
              <h3 className="text-xl font-bold text-white mb-3">Track Progress</h3>
              <p className="text-slate-400">
                See what's active, what's claimed, what's completed. Watch your local economy grow.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Use Cases */}
      <section className="py-20 px-4">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-4xl font-bold text-center text-transparent bg-clip-text bg-gradient-to-r from-orange-400 to-yellow-400 mb-16">
            Real-World Examples
          </h2>
          <div className="grid md:grid-cols-2 gap-8">
            <div className="bg-gradient-to-br from-slate-900/80 to-slate-800/80 border border-orange-500/20 rounded-xl p-8 backdrop-blur-sm">
              <div className="flex items-start gap-4">
                <span className="text-5xl">☕</span>
                <div>
                  <h3 className="text-2xl font-bold text-white mb-3">Coffee Shop in Da'an District</h3>
                  <p className="text-slate-300 mb-4">
                    250K sats bounty. Three Taipei Bitcoiners stacked sats on this. Someone claimed it,
                    onboarded the business, community verified with actual purchases.
                  </p>
                  <div className="text-emerald-400 font-bold">
                    ✓ 33% paid immediately. 67% in 3 months if still accepting.
                  </div>
                </div>
              </div>
            </div>
            <div className="bg-gradient-to-br from-slate-900/80 to-slate-800/80 border border-orange-500/20 rounded-xl p-8 backdrop-blur-sm">
              <div className="flex items-start gap-4">
                <span className="text-5xl">💈</span>
                <div>
                  <h3 className="text-2xl font-bold text-white mb-3">Barber Shop in Central Edmonton</h3>
                  <p className="text-slate-300 mb-4">
                    100K sats bounty. Local Bitcoiner approaches their regular barber, helps them set up
                    Breez wallet, gets first haircut paid in sats.
                  </p>
                  <div className="text-amber-400 font-bold">
                    ⏳ Pending community verification
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 px-4 bg-gradient-to-br from-orange-500/5 to-yellow-500/5">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-4xl md:text-5xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-orange-400 to-yellow-400 mb-6">
            Ready to Build the Bitcoin Economy?
          </h2>
          <p className="text-xl text-slate-300 mb-10">
            Join Bitcoin communities around the world coordinating merchant adoption, one bounty at a time.
          </p>
          <div className="flex gap-4 justify-center flex-wrap">
            <button
              onClick={() => setShowSignUp(true)}
              className="px-8 py-4 bg-gradient-to-r from-orange-500 to-yellow-500 hover:from-orange-600 hover:to-yellow-600 text-slate-950 font-bold text-lg rounded-lg transition-all duration-300 transform hover:scale-105 shadow-2xl hover:shadow-orange-500/50"
            >
              Get Started ⚡
            </button>
            <button
              onClick={handleQuickStart}
              className="px-8 py-4 bg-slate-800/50 border border-slate-700 hover:border-orange-500/50 text-white font-bold text-lg rounded-lg transition-all duration-300 backdrop-blur-sm"
            >
              Browse Bounties
            </button>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="py-8 px-4 border-t border-slate-800">
        <div className="max-w-6xl mx-auto text-center text-slate-500">
          <p className="mb-2">Built with ⚡ at bitcoin++ Taipei 2025</p>
          <p className="text-sm">
            No custody. No escrow. Just coordination.
          </p>
        </div>
      </footer>
    </div>
  );
};

export default LandingPage;
